import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../components/layout/Logo';
import { Footer } from '../../components/layout/Footer';

export function LegalLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <header className="bg-[#3A3C3E]">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="inline-flex items-center gap-3">
            <Logo className="h-8 text-white" />
            <span className="text-white/90 text-sm font-semibold tracking-wide">Legal</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link to="/register" className="text-sm font-medium text-white/85 hover:text-white underline">
              Sign Up
            </Link>
            <Link to="/login" className="text-sm font-medium text-white/85 hover:text-white underline">
              Sign In
            </Link>
          </div>
        </div>
      </header>

      <main className="flex-1 px-4 py-10">
        <div className="max-w-4xl mx-auto">{children}</div>
      </main>

      <Footer variant="landing" />
    </div>
  );
}

